<template>
  <div>
    <div class="top-links-desktop">
      <ul id="nav-ul" :class="!isRtl ? 'right-border' : 'left-border'">
        <li
          :class="!isRtl ? 'en-font-size' : 'ku-font-size'"
          @click="navigateTo('my-achievement')"
        >
          {{ $t('My Companies') }}
        </li>
        <li
          :class="!isRtl ? 'en-font-size' : 'ku-font-size'"
          @click="navigateTo('about-me')"
        >
          {{ $t('My achievements') }}
        </li>
        <li
          :class="!isRtl ? 'en-font-size' : 'ku-font-size'"
          @click="navigateTo('contact-me')"
        >
          {{ $t('Contact me') }}
        </li>
      </ul>
      <ul class="social-ul">
        <li>
          <a href="https://www.facebook.com/sarkhel.saeed" target="_blank">
            <img src="../assets/fb_logo.png" width="25" alt="" />
          </a>
        </li>
        <li>
          <a href="https://www.instagram.com/sarkhelll/?hl=en" target="_blank">
            <img src="../assets/instagram.png" width="25" alt="" />
          </a>
        </li>
        <li>
          <a
            href="https://www.linkedin.com/in/sarkhel-saeed-27b890140/"
            target="_blank"
          >
            <img src="../assets/linkedin.png" width="30" alt="" />
          </a>
        </li>
        <li>
          <div class="select-container">
            <div class="locale-text" @click="toggleOptions()">
              {{
                $i18n.locale === 'en'
                  ? 'English'
                  : $i18n.locale === 'ku'
                  ? 'کوردی'
                  : 'العربی'
              }}
              <img
                class="chevron-down"
                src="../assets/down-chevron.png"
                width="13"
              />
            </div>
            <ul class="locale-options">
              <li @click="changeLocale('en')">English</li>
              <li @click="changeLocale('ku')">کوردی</li>
              <li @click="changeLocale('ar')">العربی</li>
            </ul>
          </div>
        </li>
      </ul>
    </div>

    <div class="top-links-mobile">
      <div :class="!isRtl ? 'menu-btn' : 'rtl-menu-btn'" @click="toggleMenu()">
        <div class="menu-btn__burger"></div>
      </div>
      <div class="dropdown-content">
        <ul id="mobile-nav-ul">
          <li @click="toggleMenu(), navigateTo('my-achievement')">
            {{ $t('My Companies') }}
          </li>
          <li @click="toggleMenu(), navigateTo('about-me')">
            {{ $t('My achievements') }}
          </li>
          <li @click="toggleMenu(), navigateTo('contact-me')">
            {{ $t('Contact me') }}
          </li>
        </ul>

        <div class="mobile-locales">
          <div class="mobile-lang" @click="changeLocale('en')">English</div>
          <div class="mobile-lang" @click="changeLocale('ku')">کوردی</div>
          <div class="mobile-lang" @click="changeLocale('ar')">العربی</div>
        </div>

        <ul id="mobile-social-ul">
          <li>
            <a href="https://www.facebook.com/sarkhel.saeed" target="_blank">
              <img src="../assets/fb_logo.png" width="30" alt="" />
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/sarkhelll/?hl=en"
              target="_blank"
            >
              <img src="../assets/instagram.png" width="30" alt="" />
            </a>
          </li>
          <li>
            <a
              href="https://www.linkedin.com/in/sarkhel-saeed-27b890140/"
              target="_blank"
            >
              <img src="../assets/linkedin.png" width="30" alt="" />
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data() {
    return {
      menuOpen: false
    }
  },

  computed: {
    ...mapGetters({
      isRtl: 'getRtl'
    })
  },

  methods: {
    ...mapActions({
      setLocale: 'setLocale',
      setRtl: 'setRtl'
    }),

    toggleOptions() {
      const options = document.querySelector('.locale-options')
      if (options.style.display === 'none') {
        options.style.display = 'block'
      } else {
        options.style.display = 'none'
      }
    },

    changeLocale(locale) {
      const app = document.querySelector('#app')
      this.toggleOptions()
      this.setLocale(locale)
      if (locale === 'en') {
        app.style.direction = 'ltr'
        this.setRtl(false)
      } else {
        app.style.direction = 'rtl'
        this.setRtl(true)
      }
      this.$i18n.locale = locale
    },

    navigateTo(section) {
      window.scrollTo(0, document.getElementById(section).offsetTop)
    },

    toggleMenu() {
      const menuBtn = document.querySelector('.menu-btn')
      const rtlMenuBtn = document.querySelector('.rtl-menu-btn')
      const drop = document.querySelector('.dropdown-content')

      if (!this.menuOpen) {
        if (menuBtn) {
          menuBtn.classList.add('menu-opened')
        }
        if (rtlMenuBtn) {
          rtlMenuBtn.classList.add('menu-opened')
        }
        this.menuOpen = true
      } else {
        if (menuBtn) {
          menuBtn.classList.remove('menu-opened')
        }
        if (rtlMenuBtn) {
          rtlMenuBtn.classList.remove('menu-opened')
        }
        this.menuOpen = false
      }

      if (drop.style.display === 'none' || drop.style.display === '') {
        drop.style = 'display: block; transition: all 0.5 ease-in-out'
      } else {
        drop.style = 'display: none; transition: all 0.5 ease-in-out'
      }
    }
  }
}
</script>

<style lang="scss">
$secondaryColor: #e01e37;
$primaryColor: #38285a;
$backgroundColor: #e1e5e8;

.en-font-size {
  font-size: 18px;
}
.ku-font-size {
  font-size: 22px;
}
.top-links-desktop {
  display: flex;
  padding-top: 15px;
}
.right-border {
  border-right: 2px solid #38285ad2;
}
.left-border {
  border-left: 2px solid #38285ad2;
}
#nav-ul {
  list-style: none;
  display: inline-block;
  margin-top: 5px;
  padding: 10px 20px;
}
#nav-ul > li {
  color: $secondaryColor;
  display: inline;
  padding: 10px 15px;
}
#nav-ul > li:hover {
  cursor: pointer;
  background-color: $secondaryColor;
  color: #eee;
  border-radius: 4px;
  transition: all 0.3s;
}
.social-ul {
  list-style: none;
  display: inline-block;
}
.social-ul > li {
  display: inline;
  padding: 0px 20px 0px 0px;
}
.top-links-mobile {
  position: relative;
}
// Menu btn
.menu-btn,
.rtl-menu-btn {
  position: relative;
  display: none;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  cursor: pointer;
  transition: all 0.5s ease-in-out;
  z-index: 2000;
}
.menu-btn__burger {
  position: absolute;
  width: 40px;
  height: 2px;
  border-radius: 5px;
  background-color: $primaryColor;
  box-shadow: 0 2px 5px rgba(255, 101, 47, 0.2);
  transition: all 0.5s ease-in-out;
}
.menu-btn__burger::before,
.menu-btn__burger::after {
  content: '';
  position: absolute;
  height: 2px;
  border-radius: 5px;
  background-color: $primaryColor;
  box-shadow: 0 2px 5px rgba(255, 101, 47, 0.2);
  transition: all 0.5s ease-in-out;
}
.menu-btn__burger::before {
  margin-left: 15px;
  width: 25px;
  transform: translateY(-10px);
}
.menu-btn__burger::after {
  width: 25px;
  transform: translateY(10px);
}

// Menu animation
.menu-btn.menu-opened .menu-btn__burger {
  transform: translateX(-50px);
  background: transparent;
}
.menu-btn.menu-opened .menu-btn__burger::before {
  transform: rotate(45deg) translate(25px, -28px);
}
.menu-btn.menu-opened .menu-btn__burger::after {
  transform: rotate(-45deg) translate(38px, 36px);
}

// Menu animation RTL
.rtl-menu-btn.menu-opened .menu-btn__burger {
  transform: translateX(-50px);
  background: transparent;
  box-shadow: none;
}
.rtl-menu-btn.menu-opened .menu-btn__burger::before {
  transform: rotate(45deg) translate(35px, -35px);
}
.rtl-menu-btn.menu-opened .menu-btn__burger::after {
  transform: rotate(-45deg) translate(35px, 36px);
}

// Dropdown
.dropdown-content {
  display: none;
  position: absolute;
  top: 0;
  background-color: $backgroundColor;
  width: 100%;
  height: 100vh;
  z-index: 1000;
  transition: all 0.5 ease-in-out;
}

#mobile-nav-ul {
  list-style: none;
  // font-weight: bold;
  padding-left: 20px;
}
#mobile-nav-ul > li {
  font-size: 22px;
  margin: 40px 0px 70px 0px;
  color: $secondaryColor;
  cursor: pointer;
}
#mobile-nav-ul > li:first-child {
  margin-top: 70px;
}

#mobile-social-ul {
  position: absolute;
  bottom: 80px;
  // left: 0;
  list-style: none;
  display: inline-block;
}
#mobile-social-ul > li {
  display: inline;
  padding-right: 40px;
}
.select-container {
  padding: 4px 8px;
  display: inline-block;
  border: 1px solid $primaryColor;
  border-radius: 4px;
  margin-top: -5px;
  position: relative;
}
.locale-text {
  cursor: pointer;
}
.locale-options {
  display: none;
  position: absolute;
  top: 35px;
  left: 0;
  list-style: none;
  padding: 6px 0px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  border: 1px solid #e4e7ed;
  background-color: #fff;
  border-radius: 4px;
  min-width: 100px;
  transition: all 0.2s;
  user-select: none;
}
.locale-options > li {
  font-size: 16px;
  padding: 0 20px;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #606266;
  height: 34px;
  line-height: 34px;
  box-sizing: border-box;
  cursor: pointer;
}
.locale-options > li:hover {
  background-color: #e4e7ed;
}
.chevron-down {
  padding: 0px 6px;
}
.mobile-locales {
  margin-top: 5px;
  padding-left: 0px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0px 20px;
}

.mobile-lang {
  color: $primaryColor;
  width: 32%;
  font-size: 18px;
}
.mobile-lang {
  width: 30%;
  padding: 10px 4px;
}
.mobile-lang:hover {
  cursor: pointer;
  background-color: $secondaryColor;
  color: $backgroundColor;
  transition: all 0.3s;
  border-radius: 4px;
}
</style>
